import React from 'react';
import { Star, LucideIcon } from 'lucide-react';

interface RatingControlProps {
  value: number;
  max?: number;
  readOnly?: boolean;
  onChange: (value: number) => void;
  icon?: LucideIcon;
  activeColor?: string;
  inactiveColor?: string;
  labels?: string[];
  className?: string;
  size?: number;
}

export const RatingControl: React.FC<RatingControlProps> = ({
  value,
  max = 5,
  onChange,
  icon: Icon = Star,
  activeColor = 'text-yellow-500',
  inactiveColor = 'text-gray-300 dark:text-zinc-600',
  labels,
  className,
  size = 24,
  readOnly = false,
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="flex gap-2">
        {Array.from({ length: max }).map((_, i) => {
          const level = i + 1;
          const isActive = level <= value;
          return (
            <button
              key={level}
              type="button"
              onClick={() => !readOnly && onChange(level)}
              disabled={readOnly}
              className={`transition-all duration-200 focus:outline-none ${!readOnly ? 'hover:scale-110 cursor-pointer' : 'cursor-default'} ${isActive ? activeColor : inactiveColor}`}
            >
              <Icon size={size} fill={isActive ? 'currentColor' : 'none'} strokeWidth={2} />
            </button>
          );
        })}
      </div>
      {labels && labels[value - 1] && (
        <span className="text-xs font-medium text-gray-500 mt-1 animate-in fade-in">
          {labels[value - 1]}
        </span>
      )}
    </div>
  );
};
